import React, { useState } from 'react'
import './Assets.css'
import carImage from '../../assets/car4.png'
import ReactApexChart from 'react-apexcharts'
import { carActivity } from '../../utilits/statisticTools'
import { avaliable, notices } from '../../utilits/assetsNotices'
import { table } from '../../utilits/assetsTable'
import AddModal from '../../components/AddModal'

export default function Assets() {

  const [activeBtn, setActiveBtn] = useState('0')
  const [checkBox, setCheckBox] = useState('[]')

  return (
    <div className='assets'>
        <h1 className='assets-title'>Assets</h1>
        <div className="assets-main">
          <div className="assets-left">
              <div className="assets-left-title">
                <div className="assets-title-top">
                  <div className='assets-title_left'>
                    <h3>Fuel Usage</h3>
                    <h4>2903.89 Ltr</h4>
                  </div>
                  <div>
                    <h3>KM Driven</h3>
                    <h4>2903.89 Ltr</h4>
                  </div>
                </div>
                <div className="assets-title-bottom">
                  <div className='assets-title_left'>
                    <h3>Total Cost</h3>
                    <h4>$3,00,290.00</h4>
                  </div>
                  <div>
                    <h3>Top Speed</h3>
                    <h4>$5.2K</h4>
                  </div>
                </div>
              </div>
              <div className="assets-image">
                <img src={carImage} alt="" />
              </div>
          </div>

          <div className="assets-right">
            <div className="assets-right_area">
              <h1>Activity</h1>
              <ReactApexChart options={carActivity.options} series={carActivity.series} type="line" height={250} />
            </div>
            <div className="assets-right_center">
              <div className="center-notices">
                <h2>Notices</h2>
                {
                  notices.map((element, value) =>{
                    return <div className='notice-items'>
                      <div className='notice-items_icon'>{element.icon}</div>
                      <div>
                        <h3>{element.name}</h3>
                        <p>{element.notices}</p>
                        <button  className={activeBtn === element.btn ? 'activeBtn' : "notice-btn" } key={value} onClick={()=> setActiveBtn(element.btn)}>{element.btn}</button>
                      </div>
                    </div>
                  })
                }
              </div>
              <div className="center-available">
                <h2>Available Sensors</h2>
                {
                   avaliable.map((element, value) =>{
                    return <div className='available-items'>
                      <form className='available-form' action="">
                        <input type="checkbox"/>
                        <label>{element.name}</label>
                      </form>
                      <div className='available-icon'><span>{element.icon}</span></div>
                    </div>
                   })
                }
                <button>See All</button>
              </div>
            </div>

            <div className="assets-right_bottom">
              <div className="assets-reminder">
                <div className="assets-reminder_top">
                  <h2>Reminder</h2>
                  <button>+ Add New</button>
                </div>
                <div className="assets-reminder_bottom">
                  <table>
                    <th>Description</th>
                    <th>Due</th>
                    <th>Overdue</th>
                    <th>Notify</th>
                    <th>Status</th>
                    {
                      table.map((element, value)=>{
                        return <tr>
                          <td>{element.tdesc}</td>
                          <td>{element.tdue}</td>
                          <td>{element.toverdue}</td>
                          <td>{element.tnotify}</td>
                          <td>{element.tstatus}</td>
                        </tr>
                      })
                    }
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <AddModal/> */}
    </div>
  )
}
